import { render } from "./webview.html?vue&type=template&id=ffb4b078&scoped=true&ts=true"
import script from "./webview.vue?vue&type=script&lang=ts"
export * from "./webview.vue?vue&type=script&lang=ts"

import "./webview.scss?vue&type=style&index=0&id=ffb4b078&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb4b078"]])

export default __exports__